import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from "@angular/router";
import IErrorResolver from "@models/IErrorResolver.model";
import { Observable, of } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ErrorResolver implements Resolve<IErrorResolver> {
  constructor(public router: Router) {}

  resolve(
    route: ActivatedRouteSnapshot,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    state: RouterStateSnapshot,
  ): Observable<IErrorResolver> | Promise<IErrorResolver> {
    const errorId = route.params["itemId"];

    return of({ ErrorCode: errorId });
  }
}
